const ENTITY = 'data-qa-entity';
const PAYLOAD = 'data-qa-payload';

interface AutomationLabelsProps {
  'data-qa-entity'?: string;
  'data-qa-payload'?: string;
  [key: string]: any;
}

export const extractProps = (props: AutomationLabelsProps): AutomationLabelsProps => {
  if (!props[ENTITY]) {
    return {};
  }

  const newProps: AutomationLabelsProps = {
    [ENTITY]: props[ENTITY],
  };

  if (props[PAYLOAD]) {
    newProps[PAYLOAD] = props[PAYLOAD];
  }

  return newProps;
};

export function getProps(entityName: string, data?: object): AutomationLabelsProps {
  const props: AutomationLabelsProps = {
    [ENTITY]: entityName,
  };

  try {
    if (data) {
      props[PAYLOAD] = JSON.stringify(data);
    }
  } catch (ignored) {
    console.error(ignored);
  }

  return props;
}
